<template>
  <v-app id="inspire">
    <router-view v-if="this.$store.state.user"/>
    <Notification />
  </v-app>
</template>

<script>
import { getUser, hasWriteWorkspace } from '@/utils/auth';

import Notification from '@/components/TheNotification';
import { getToken } from './utils/auth';

export default {
  components: {
    Notification
  },
  async created() {
    this.$store.state.loading = true;
    this.$store.commit('setUser', await getUser(getToken(), window.location.origin));
    this.$store.commit('setCanWrite', await hasWriteWorkspace(getToken(), window.location.origin));
    this.$store.state.loading = false
  }
};
</script>

<style lang="scss">
  .border {
    border: 1px solid #ccc;
  }

 .inline {
   display: inline-block;
 }
 
 .v-application--wrap {
  justify-content: flex-end;
 }
</style>

